import { GetShippingCompanyList_shipping_company_list } from './index_types.2';

/**
 * 택배사 코드로 택배사 이름을 반환한다.
 * @param shipping_company_code 택배사 코드
 */
export const getShippingCompanyNameByCode = (
  shipping_company_code: string,
  shipping_company_list?: GetShippingCompanyList_shipping_company_list[],
): string => {
  const shipping_company = (shipping_company_list || []).find((item) => item.code === shipping_company_code);
  if (!shipping_company) {
    return '-';
  }
  return shipping_company.name;
};

/**
 * 언어에 따른 택배사옵션리스트를 반환한다.
 * @param lang 언어
 * @returns value: 택배사코드, text: 언어별 택배사이름
 */
export const getShippingCompanyOptionList = (
  shipping_company_list?: GetShippingCompanyList_shipping_company_list[],
) => {
  return (shipping_company_list || []).map((shipping_company) => ({
    value: shipping_company.code,
    text: shipping_company.name,
  }));
};
